// Shared phrases of field hints and "View on the website" links (rez 10, F9.6). The keys are
// frozen by the slice contract: FieldHint and TabWebLink compose them with the per-editor
// texts in destination.ts, trip.ts, inspiration.ts and guide.ts.
export const common = {
  webPrefix: "On the website:",
  backofficePrefix: "Not shown on the website, used for",
  viewOnWeb: "View on the website",
  notPublished: "content is not published",
  notSavedYet: "after saving and publishing",
  tabBackoffice: "The tab content is not shown on the website, it is used for {{purpose}}.",
};
